import { render, staticRenderFns } from "./user-renewal.vue?vue&type=template&id=1be789ac&scoped=true&"
import script from "./user-renewal.vue?vue&type=script&lang=js&"
export * from "./user-renewal.vue?vue&type=script&lang=js&"
import style0 from "./user-renewal.vue?vue&type=style&index=0&id=1be789ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be789ac",
  null
  
)

export default component.exports